export default "__VITE_ASSET__0c79def4__"